import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { useTranslation } from "react-i18next";
import SitemapGroupRow from "./SitemapGroupRow";
import React, { Fragment } from "react";
import SitemapGroupDialog from "./dialog/SitemapGroupDialog";
import { isArrayEmpty, isArrayNotEmpty, TableButton } from "@duosoftbg/nacid-components";
import { SitemapEmptyListAlert } from "./SitemapEdit";
import SitemapDeleteGroupDialog from "./dialog/SitemapDeleteGroupDialog";
import SitemapSubGroupDialog from "./dialog/SitemapSubGroupDialog";
import SitemapLinkDialog from "./dialog/SitemapLinkDialog";
import SitemapDeleteSubGroupDialog from "./dialog/SitemapDeleteSubGroupDialog";
import SitemapDeleteLinkDialog from "./dialog/SitemapDeleteLinkDialog";
import { sitemapGroupCreationInitialValues } from "../../../../../init/sitemapCreationInitialValues";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { openEditModal } from "../../../../../store/redux/slice/ComponentsControl/sitemapControl";
import { sitemapSection } from "../../../../../utils/constants";

const SitemapEditList = ({ siteMap }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onClickCreateGroupButton = () => {
    dispatch(openEditModal({ section: sitemapSection.group, object: sitemapGroupCreationInitialValues }));
  };

  return (
    <Fragment>
      <SitemapLinkDialog></SitemapLinkDialog>
      <SitemapSubGroupDialog></SitemapSubGroupDialog>
      <SitemapGroupDialog></SitemapGroupDialog>
      <SitemapDeleteGroupDialog></SitemapDeleteGroupDialog>
      <SitemapDeleteSubGroupDialog></SitemapDeleteSubGroupDialog>
      <SitemapDeleteLinkDialog></SitemapDeleteLinkDialog>
      <TableContainer>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 35 }} />
              <TableCell>{t("l.table.head.id")}</TableCell>
              <TableCell>{t("l.table.head.groupName")}</TableCell>
              <TableCell>{t("l.table.head.groupNameEn")}</TableCell>
              <TableCell>{t("l.table.head.position")}</TableCell>
              <TableCell align="right">
                <TableButton type={"create"} onClick={onClickCreateGroupButton} />
              </TableCell>
            </TableRow>
          </TableHead>
          {isArrayNotEmpty(siteMap) && (
            <TableBody>
              {siteMap.map((item) => (
                <SitemapGroupRow key={item.mainGroup.id} sitemapItem={item} />
              ))}
            </TableBody>
          )}
        </Table>
        {isArrayEmpty(siteMap) && <SitemapEmptyListAlert severity="info">{t("m.empty.list")}</SitemapEmptyListAlert>}
      </TableContainer>
    </Fragment>
  );
};

export default SitemapEditList;
